import { createSelector } from 'reselect'

export const stateSelector = state => state.api.get.one.webconferences

export const data = () =>
  createSelector(
    [stateSelector],
    getOneWebconferencesState => {
      if (getOneWebconferencesState.data) {
        return getOneWebconferencesState.data
      }
      return null
    }
  )

export const isLoading = () =>
  createSelector(
    [stateSelector],
    getOneWebconferencesState => getOneWebconferencesState.isLoading
  )
